export const SIGNUP_SURVEY_SHARE_BLOCKED_HEADLINE = 'Participation unavailable'

export const SIGNUP_SURVEY_SHARE_BLOCKED_MESSAGE =
  'This survey is no longer accepting new responses.'
